// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"vk_a zu_g"};